import HTTP from "@/http-common";
import { httpError } from "@/models/httpError";

export const state = {
  message: new httpError()
};

export const getters = {
  message: state => state.message
};

export const mutations = {
  SET_MESSAGE(state, message) {
    state.message = message;
  }
};

export const actions = {
  setMessage({ commit }, message) {
    commit("SET_MESSAGE", message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit("SET_MESSAGE", new httpError());
      }, 4000);
  },
  getTemplates({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get("reminder/GetReminderTemplates")
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  updateTemplate({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      HTTP.post("reminder/UpdateReminderTemplate/", item)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  addTemplate({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      HTTP.post("reminder/AddReminderTemplate/", item)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  listGroupTemplates({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get("reminder/ListReminderGroupTemplate")
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  updateGroupTemplate({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      HTTP.post("reminder/UpdateReminderGroupTemplate/", item)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  deleteTemplate({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      HTTP.post("reminder/DeleteReminderTemplate/", item)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  // letter templates
  addLetterTemplate({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      HTTP.post("reminder/CreateLetterTemplate/", item)
        .then(data => {
          dispatch(
            "setMessage",
            new httpError({
              message:
                item.get("id") != 0
                  ? "Updated template successfully!"
                  : "Added template successfully!",
              httpStatus: 200
            })
          );
          resolve(data.data);
        })
        .catch(error => {
          console.log(error);
          dispatch(
            "setMessage",
            new httpError({
              message: error.response.data,
              httpStatus: 500
            })
          );
          reject(error.message);
        });
    });
  },
  getLetterTemplate() {
    return new Promise((resolve, reject) => {
      HTTP.get("reminder/GetLetterTemplates")
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  deleteLetterTemplate({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      HTTP.post("reminder/DeleteLetterTemplate/", item)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  getLetterTemplateFile({ dispatch }, filename) {
    return new Promise((resolve, reject) => {
      HTTP.get("reminder/GetLetterTemplateFile/" + filename)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  downloadLetterTemplateFile({ dispatch }, filename) {
    return new Promise((resolve, reject) => {
      HTTP.get("reminder/DownloadLetterTemplateFile/" + filename, {
        responseType: "blob"
      })
        .then(data => {
          resolve(data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  sendLetterTemplate({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      HTTP.post(
        `reminder/SendLetterTemplate/${payload.filename}/${payload.preview}`,
        JSON.stringify(payload.data)
      )
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({ message: err.message, httpStatus: 500 })
          );
          reject(err.message);
        });
    });
  }
};
